import { InteractionModel } from '@/app/shared/models';
import { refsService as refs } from '@/app/shared/refs.service';
import { VNode } from 'vue';
import { Vue } from 'vue-property-decorator';
import { DirectiveBinding } from 'vue/types/options';

Vue.directive('track', {
  bind(el: Element, binding: DirectiveBinding) {
    const listener = () => {
      if (refs.modules.ticket.ticket.Id)
        refs.modules.ticket.createInteraction(
          new InteractionModel(
            binding.value.ActionCode,
            binding.value.Description
          )
        );
    };
    el.addEventListener('click', listener, false);
  },
});

// Directive for hiding elements when permission is not set
// usage: v-can="'code'" or v-can="'code;code;code'"
// usage: v-can="'FI132'" or v-can="'FI132;BI122'"
Vue.directive('can', {
  bind: function(el: Element, binding: DirectiveBinding, vnode: VNode) {
    if (!refs.util.hasPermission(binding.expression)) {
      const comment = document.createComment(' ');

      Object.defineProperty(comment, 'setAttribute', {
        value: () => undefined,
      });

      vnode.text = ' ';
      vnode.elm = comment;
      vnode.isComment = true;
      vnode.tag = undefined;

      vnode.data = vnode.data || {};
      vnode.data.directives = undefined;

      if (vnode.componentInstance) {
        // eslint-disable-next-line
        // @ts-ignore
        vnode.componentInstance.$el = comment;
      }

      if (el.parentNode) {
        el.parentNode.replaceChild(comment, el);
      }
    }
  },
});
